
export const timestampFormat = "YYYY-MMM-DD [at] HH:mm[am]";